import { Box } from '@mui/material'
import { DataGrid, DataGridProps } from '@mui/x-data-grid'
import { ReactNode } from 'react'
import { commonDataGridStyles } from '~/ui/styles/data-grid'

export const CustomDataGrid = ({
  sx,
  children,
  ...gridProps
}: DataGridProps & { children?: ReactNode }) => {
  return (
    <Box sx={{ position: 'relative', height: 1 }}>
      {children}
      <DataGrid
        {...gridProps}
        disableRowSelectionOnClick
        disableColumnSelector
        sx={{ ...commonDataGridStyles, ...sx } as DataGridProps['sx']}
        slotProps={{
          baseCheckbox: { name: 'checkbox' },
        }}
      />
    </Box>
  )
}
